<template>
  <v-dialog :model-value="true" max-width="800">
    <v-card>
      <v-card-title class="text-h5 error text-white">
        Duplicate store
      </v-card-title>

      <v-card-text>
        <div class="text-h6" style="line-height:1.4 !important">
          <p class="mt-2 mb-3">
            Would you like to transfer the Shopper and Client credentials to the
            new store?
          </p>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="py-3 px-3">
        <v-spacer />
        <v-btn
          color="error"
          @click="$emit('duplicate-campaign', $props.campaignId, true)"
          data-testid="cl-complete-confirm"
        >
          Yes
          <template v-slot:loader>
            <span>Duplicating...</span>
          </template>
        </v-btn>
        <v-btn
          variant="outlined"
          color="error"
          @click="$emit('duplicate-campaign', $props.campaignId, false)"
          data-testid="cl-complete-confirm"
        >
          No
          <template v-slot:loader>
            <span>Duplicating...</span>
          </template>
        </v-btn>
        <v-btn
          variant="outlined"
          color="error"
          @click="$emit('close-modal')"
          data-testid="cl-complete-cancel"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
  },
};
</script>
